import { post } from '../utilities/api'

export const postBookingUrl = (email, link) => post({
  url: '/booking/url',
  data: {
    email,
    booking_url: link
  }
})
  .then(({ data }) => data.success)
